export default {
  methods: {
    dublicate(value, list) {
      let duplicates = [];
      let values = list.slice().sort();
      for (let i = 0; i < values.length - 1; i++) {
        if (values[i + 1] == values[i]) {
          duplicates.push(values[i]);
        }
      }

      return value == '' ? false : duplicates.includes(value)
    },
  },
}